<template>
    <el-row v-if="$organization.use_label" type="flex" :gutter="5">
        <el-col class="flex-grow-1" v-if="isMobile">
            <label class="el-form-item__label" style="width: 60px;color: #2196f3">标签:</label>
            <div class="el-form-item__content" >
                <div class="el-form-item__content" style="margin-left: 60px;" @click="show_dialog=true">
                    <div class="el-textarea">
                        <div class="el-textarea__inner"
                             style="min-height: 40px; line-height: 30px;">
                             {{ labelNames }}
                        </div>
                    </div>
                </div>
            </div>
        </el-col>
        <el-col class="flex-grow-1" v-else>
            <div class="el-form-item">
                <label class="el-form-item__label" style="width: 100px;color: #2196f3">标签:</label>
                <div class="el-form-item__content" style="margin-left: 100px;">
                    <el-select v-model="labels" placeholder="标签内人员被发送通知" class="w-100" clearable filterable
                               multiple remote reserve-keyword :remote-method="remoteSearchLabel" :loading="loading">
                        <el-option v-for="(option,key) in label_list"
                                   :label="option" :value="key+''" :key="key"></el-option>
                    </el-select>
                </div>
            </div>
        </el-col>
        <el-col class="flex-grow-0" style="width: 60px;">
            <button style="width: 100%;height: 40px" type="button" class="btn btn-secondary"
                    @click="handleLabelDetail">
                <i class="fa fa-info-circle"></i>
            </button>
        </el-col>

        <mh-mobile-label-select :visible.sync="show_dialog" :value="labels"  @input="setLabels" :list.sync="label_list" @reload="remoteSearchLabel" ></mh-mobile-label-select>
    </el-row>
</template>

<script>
import mobile from "@/common/mobile-input"
import MhMobileLabelSelect from "./mh-mobile-labe-select.vue";

export default {
    name: "mh-label-select",
    components: {MhMobileLabelSelect},
    data() {
        return {
            label_list: {},
            labels: [],
            loading: false,
            show_dialog: false,
        }
    },
    computed: {
        isMobile() {
            return mobile() !== '';
        },
        labelNames() {
            let names = [];
            for (let i in this.labels) {
                if (this.label_list[this.labels[i]]) names.push(this.label_list[this.labels[i]]);
            }
            return names.join(',');
        }
    },
    watch: {
        value: {
            handler: function (val) {
                this.labels = val;
                this.remoteSearchLabel();
            },
            deep: true
        },
        labels: {
            handler: function (val) {
                this.$emit('input', val)
            },
            deep: true
        },
    },
    props: {
        single: {
            type: Object,
            default: function () {
                return {}
            }
        },
        value: {
            type: Array,
            default: function () {
                return []
            }
        },

    },
    methods: {
        setLabels(val) {
            this.labels = [...val];
            this.remoteSearchLabel();
        },
        handleLabelDetail() {
            this.$api('Query.Label.Detail', {data: this.labels}, true).then(res => {
                this.$alert('<ul><br/>' + res.data.data + '</ul>', '标签信息', {
                    showCancelButton: false,
                    dangerouslyUseHTMLString: true,
                });
            });
        },
        remoteSearchLabel(query) {
            this.loading = true;
            this.$api('Query.Label.List', {data: query, reserve: this.labels}, true).then(res => {
                this.label_list = res.data.data;
                this.loading = false;
            });
        },
    },
    mounted() {
        this.remoteSearchLabel();
    }
}
</script>

<style scoped>

</style>